import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from "react-intl";
import { Link } from 'react-router-dom';
import * as paths from '@app/constants/paths';
// nodejs library that concatenates classes
import classNames from "classnames";
import Divider from '@material-ui/core/Divider';
import FormControlLabel from "@material-ui/core/FormControlLabel";
// components
import GridContainer from '@app/components/Grid/GridContainer';
import GridItem from '@app/components/Grid/GridItem';
import Card from '@app/components/Card/Card';
import CardHeader from '@app/components/Card/CardHeader';
import CardFooter from '@app/components/Card/CardFooter';
import CardBody from '@app/components/Card/CardBody';
import Button from '@app/components/CustomButtons/Button';
import CustomInput from '@app/components/CustomInput/CustomInput';
import CustomAccordion from "@app/components/Accordion/CustomAccordion";
// material-ui-core
import Radio from '@material-ui/core/Radio';
import Typography from '@material-ui/core/Typography';
import InputAdornment from "@material-ui/core/InputAdornment";
// icons
import SaveIcon from '@material-ui/icons/Save';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
// FontIcons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import withStyles from '@material-ui/core/styles/withStyles';
import surveyPageStyle from '@app/assets/jss/material-kit-pro-react/views/surveyPageStyle';

const GrantHistoryView = (props) => {
    const classes = props.classes;

    const grantAmountError = props.validationErrors.grantAmount.show;
    const grantAmountHelperText = props.validationErrors.grantAmount.show ? props.validationErrors.grantAmount.errorMessage : '';
    
    // Section Labels
    // Options Messages
    const yes = props.intl.formatMessage({ id: "yes" });
    const no = props.intl.formatMessage({ id: "no" });
    const notSure = props.intl.formatMessage({ id: "not.sure" });
  
    return (
        <form name="trading-online-voucher-scheme-2020" onSubmit={props.onSubmit}>
            <GridContainer justify='center'>
                <GridItem xs={12} sm={10}>
                    <Card className={classes.cardSignUp}>
                        <CardHeader color='danger' className={classes.cardHeaderSignUp}>
                            <h3 className={classNames(classes.cardTitle, classes.title)}>
                                GRANT HISTORY
                            </h3>
                        </CardHeader>
                        <CardBody className={classes.cardBodySignUp}>
                            <h4 className={classes.title} id="grantHistory">
                                Has the business previously received State or EU supports?&nbsp;
                                {props. validationErrors.grantHistory.check === null ? ' ' : (props. validationErrors.grantHistory.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>
                                                    <p>Has the business or any of its promoters previously received any other State supports or EU supports from any other agencies?</p>
                                                    <p>De Minimis Aid is small amounts of State Aid given to an undertaking and/or business which cannot exceed <b>€200,000</b> over <b>any three fiscal years</b> regardless of size or location.</p>
                                                    <p>De Minimis Aid can come from any State body, agency or department. If a business is part of a group, then the €200,000 limit applies to the group.</p>
                                                    <p>Please note that a false declaration to show a figure under the threshold of €200,000 could later mean that you would have to pay back the grant aid with interest.</p>
                                                </span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                            </GridContainer>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleGrantHistory}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'euro-sign']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'euro-sign']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                checked={props.grantHistory === 'yes'}
                                                name="yes"
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                            labelPlacement="bottom"
                                            value="yes"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleGrantHistory}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fab', 'creative-commons-nc-eu']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fab', 'creative-commons-nc-eu']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="no"
                                                checked={props.grantHistory === 'no'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                            labelPlacement="bottom"
                                            value="no"
                                        />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                    <div className={classes.choice}>
                                        <FormControlLabel
                                            control={<Radio
                                                onChange={props.handleGrantHistory}
                                                checkedIcon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                icon={
                                                    <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                }
                                                classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                }}
                                                name="notSure"
                                                checked={props.grantHistory === 'notSure'}
                                            />}
                                            classes={{ label: classes.label }}
                                            label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                            labelPlacement="bottom"
                                            value="notSure"
                                        />
                                    </div>
                                </GridItem>
                            </GridContainer>
                            {props.grantHistory !== 'no' &&
                                <div> 
                                    <Divider className={classes.divider}/>
                                    <h4 className={classes.title} id="grantAmount">
                                        What is the total amount of grant aid received?&nbsp;
                                        {props. validationErrors.grantAmount.check === null ? ' ' : (props. validationErrors.grantAmount.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                                    </h4>
                                    <GridContainer justify='center'>
                                        <GridItem xs={12} sm={12} md={8}>
                                            <CustomInput
                                                id='grantAmount'
                                                labelText='Amount Requested'
                                                helperText={grantAmountHelperText}
                                                error={grantAmountError}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                                inputProps={{
                                                    placeholder: '199999',
                                                    name: ' grantAmount',
                                                    value: props.grantAmount,
                                                    onChange: props.handleGrantAmount,
                                                    autoComplete: 'off',
                                                    startAdornment: (
                                                        <InputAdornment position='start'>
                                                            <FontAwesomeIcon icon={['fas', 'euro-sign']} className={classes.inputIconsColor} />
                                                        </InputAdornment>
                                                    ),
                                                    type: 'number'
                                                }}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                </div>
                            }
                        </CardBody>
                        <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <Button color="gray" component={ Link } to={paths.HELPER_T_O_V_S}>
                                    Main Menu
                                </Button>
                                <Button
                                    color="primary"
                                    size="sm"
                                    startIcon={<SaveIcon />}
                                    onClick={props.generateDoc}
                                >
                                    Download
                                </Button>
                            </div>
                        </CardFooter>
                        <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <Button color='primary' component={ Link } to={paths.HELPER_T_O_V_S_COSTS}>
                                    &lt; Project Costs 
                                </Button>
                                <Button color='primary' component={ Link } to={paths.HELPER_T_O_V_S_ABOUT}>
                                    About Your Business &gt;&gt;
                                </Button>
                            </div>
                        </CardFooter>
                    </Card>
                </GridItem>
            </GridContainer>
        </form> 
    );
}

GrantHistoryView.propTypes = {
    locale: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    handleGrantHistory: PropTypes.func.isRequired,
    handleGrantAmount: PropTypes.func.isRequired,
    generateDoc: PropTypes.func.isRequired
};

export default injectIntl(withStyles(surveyPageStyle)(GrantHistoryView));